import React, { useEffect, useState } from 'react';
import './style.scss';
import '../style.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { useHistory, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom';
import PaymentResult from '../PaymentResult/PaymentResult';

const PaymentNoti = () => {
  const params = useParams();
  const useQuery = () => new URLSearchParams(useLocation().search);
  const history = useHistory();
  const { slug } = params;
  const token = useQuery().get('token');
  const data = JSON.parse(sessionStorage.getItem('dataQueryTransactionInfo'));

  useEffect(() => {
    if (!data) {
      const encodedToken = encodeURIComponent(token);
      history.replace(`/thanhtoan/roaming?token=${encodedToken}`);
    }
  }, [data, history]);

  return (
    <div id="qr-code__payment-noti">
      <Header />
      <PaymentResult type={slug} data={data} /> 
      <Footer /> 
    </div>
  );
}

export default React.memo(PaymentNoti);
